function initializePopoversBottom() {
    $('p.option').each(function() {
        $(this).css('margin-bottom', '5px');
    });

    var ids = $('#ids-productos-shopping-inline').attr('value').split(',');
    for (var i = 1; i < ids.length; i++) {
        $('#a-shop-in-' + ids[i]).attr('data-placement', 'bottom');
        $('#a-shop-in-' + ids[i]).popover({
            html    : true,
            content :  $('#shop-in-'+ids[i]).html()/* 'ok' + $(this).closest('p').attr('id')*/
        });
    }
}

function initializePopovers() {
    var ids = $('#ids-productos-shopping-inline').attr('value').split(',');
    for (var i = 1; i < ids.length; i++) {
        $('#a-shop-in-' + ids[i]).popover({
            html    : true,
            content :  $('#shop-in-'+ids[i]).html()/* 'ok' + $(this).closest('p').attr('id')*/
        });

    }
}

function setCookieForCookiesDisc() {
    $.ajax({
        url:'/setCookieForCookiesDisc',
        data: {},
        dataType: 'json',
        type:'POST',
        error:
            function(){
                ;
            },
        success:
            function(data){
                $('#cookies-alert').fadeOut(200);
            }
    });
}

function voteOpinion(id_opinion, voto) {
    $.ajax({
        url:'voteOpinion?id_opinion=' + id_opinion + '&voto=' + voto,
        data: {},
        dataType: 'json',
        type:'POST',
        error:
            function(){
                ;
            },
        success:
            function(data){
                $('#footer_' + id_opinion).html('<span class="color-success">¡Gracias!</span>');
            }
    });
}

function addItemInline(r) {
    /*var prev_total = $('#shopping-cart-total').html();
    if (prev_total == '')
        prev_total = 0;
    total = parseInt(prev_total) + parseInt($(r).attr('value'));
    $('#shopping-cart-total').html(total);*/
    $(r).closest('form').submit();
}

function check_email(e) {
    ok = "1234567890qwertyuiop[]asdfghjklzxcvbnm.@-_QWERTYUIOPASDFGHJKLZXCVBNM";
    for(i=0; i < e.length ;i++){
        if(ok.indexOf(e.charAt(i))<0){
            return (false);
        }
    }
    if (document.images) {
        re = /(@.*@)|(\.\.)|(^\.)|(^@)|(@$)|(\.$)|(@\.)/;
        re_two = /^.+\@(\[?)[a-zA-Z0-9\-\.]+\.([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        if (!e.match(re) && e.match(re_two)) {
            return (-1);
        }
    }
}

function check_form(f) { // f is the form (passed using the this keyword)
    // check the first email address ( the exclamation means "not" )
    if(!check_email(f.email.value)){
        f.email.focus();
        var n = f.num.value;
        d = document.getElementById('frm_msg_' + n);
        d.style.color = "red";
        d.style.display = "";
        f.email.style.background = "#FFFF99";
        //d.innerHTML = '<tal:block><span i18n:translate="" tal:omit-tag="">!Escriba un e-mail correcto</span><span i18n:translate="" tal:omit-tag=""><span i18n:name="punt" tal:omit-tag="">:</span></span></tal:block>';
        d.innerHTML = document.getElementById('mail_correcto_msg_' + n).innerHTML;
        // make sure the form is not submitted
        return false;
    } else {
        // set cookie a period of two days
        $.cookie('show_modal_newsletter_suscription', 0, {expires: 2, path:'/'})
        return true;
    }
}

function subs_newsletter_promo(f) {
    if (check_form(f)) {
      $.ajax({
        url:f.portal_url.value + '/manageSuscripcionBoletin?op=' + f.op.value + '&subject=' + f.subject.value + '&lang=' + f.lang.value + '&email=' + f.email.value + '&ajax_call=True',
        dataType: 'json',
        type:'GET',
        error:
            function(){
                console.log('Ha sucedido algún error');
            },
        success:
            function(data){
                $('#modal-newsletter-promo-' + data['res']).fadeIn(300);
                $('#modal-newsletter-promo-form').hide();
            }
      });
    }
    return false;
}

function subs_newsletter_avanzada(f) {
    if (check_form(f)) {
      $.ajax({
        url:f.portal_url.value + '/async/manageSuscripcionAvanzada?lang=' + f.lang.value + '&email=' + f.email.value + '&id_site=' + f.id_site.value,
        data: {},
        dataType: 'json',
        type:'GET',
        error:
            function(){
                h = '<p class="color-red">Ha ocurrido un error durante su solicitud de suscripción.<br/><br/>Probablemente ya esté dado de alta con dicha dirección de correo electrónico.</p>';
                $('#premier-container').html(h);
            },
        success:
            function(data){
                h = '<p class="color-success">Hemos registrado correctamente su solicitud de suscripción.<br /><br />Le avisaremos en cuanto comience la campaña.<br/><br/>Muchas gracias.</p>';
                $('#premier-container').html(h);
            }
      });
    }
    return false;
}

function recalculateVarPrice() {
    var q = parseInt($("#text_quantity").val());
    if (isNaN(q)) {
        $('#precio-s-cant').html('0');
        if ($('#bot-reg-s-cant').length)
            $('#bot-reg-s-cant').html('0');
    } else {
        // calcular el nuevo precio
        var price = parseFloat($('#unit-price').attr('value'));
        var iva_general = parseFloat($('#iva-general').attr('value')) + 1.00;
        var new_price = String((q * price * iva_general).toFixed(2));

        var decimal_notation = ','
        if ($('#curr_lang').attr('value') == 'en')
            decimal_notation = '.'
        var currency = $('#curr-currency').attr('value');
        if (typeof currency === "undefined")
            currency = "euro"

        // si tiene precio especial, y se ha puesto mas items de los requeridos par empezar a aplicar dto, aplicar!
        if ($('#special-unit-price').length) {
            var min_special_q = parseInt($('#n-special-unit-price').attr('value'));
            if (q >= min_special_q) {
                // si se escondieron elementos, resacarlos
                if ($('#price-without-discount').is(':hidden')) {
                    $('#price-without-discount').show();
                    $('#discount-text').show();
                    $('#units-txt').removeClass('color-black');
                    $('#precio-s-cant').removeClass('color-black');
                }
                var price_wo_disc = price;
                price = parseFloat($('#special-unit-price').attr('value'));
                new_price = String((q * price * iva_general).toFixed(2));
                // recalcular price-without-discount
                var new_price_wo_disc_no_iva = q * price_wo_disc;
                var new_price_wo_disc_str = show_price_formatted(String((new_price_wo_disc_no_iva * iva_general).toFixed(2)), decimal_notation, currency);
                $('#price-without-discount').html(new_price_wo_disc_str);
                // recalcular saved-price
                var new_saved_price_wo_iva = (price_wo_disc * q).toFixed(2) - (price * q).toFixed(2);
                var new_saved_price_str = show_price_formatted(String((new_saved_price_wo_iva * iva_general).toFixed(2)), decimal_notation, currency);
                $('#saved-price').html(new_saved_price_str);
            } else {
                $('#units-txt').addClass('color-black');
                $('#precio-s-cant').addClass('color-black');
                $('#price-without-discount').hide();
                $('#discount-text').hide();
            }
        }
        if (q == 1)
            $('#units-txt').html($('#singular-i18n-units-txt').attr('value'));
        else
            $('#units-txt').html($('#plural-i18n-units-txt').attr('value'));
        new_price = show_price_formatted(new_price, decimal_notation, currency);
        $('#precio-s-cant').html(new_price);
        // si tiene promo (+N gratis), recalcular N
        if ($('#bot-reg-s-cant').length) {
            var new_q_promo = parseInt(q / parseInt($('#uni-compra').attr('value')) * parseInt($('#uni-promo').attr('value')));
            $('#bot-reg-s-cant').html(new_q_promo);
        }
    }
    return false;
}

function show_price_formatted(price, decimal_notation, currency) {
    // price es un STRING del precio, que siempre es de la forma X.YY (con punto)
    // decimal_notation es el separador que se utilizará según l10n
    // currency es la moneda actual
    price = price.replace('.', decimal_notation);
    if (currency == 'euro')
        price = price + ' &euro;';
    else
        price = '&pound;' + price;
    return price;
}

function activate_nav_tabs() {
    $('.nav-tabs a').click(function (e) {
        e.preventDefault();
        $(this).tab('show');
    });
}

function reselectProv(start) {
    start = typeof start !== 'undefined' ? start : false;
    var id_provincia = document.getElementById("id_provincia_h").value;
    var select_provincias = document.getElementById("provincia");
    var id_pais = document.getElementById("s_id_pais").value;
    var id_pais_default = document.getElementById("id_pais_default").value;
    if (id_provincia == '00' || id_provincia == '') {
        if (id_pais == id_pais_default && select_provincias.selectedIndex == (select_provincias.length - 1) ) {
            select_provincias.selectedIndex = "0";
        } else if (id_pais != id_pais_default) {
            select_provincias.selectedIndex = select_provincias.length - 1;
        }
    } else {
        if (id_pais != id_pais_default)
            select_provincias.selectedIndex = select_provincias.length - 1;
        else
            if (!start && select_provincias.selectedIndex == (select_provincias.length - 1))
                select_provincias.selectedIndex = "0";
    }
}


function noCrawlValoracionProd() {
    $.ajax({
        url:$('#portal_url').val() + '/noCrawlContent',
        data: {'id_producto': $('#id_producto').val()},
        dataType: 'json',
        type:'POST',
        error:
            function(){
                ;
            },
        success:
            function(data){
                if (data['res']) {
                    $('#content_valoracion_i18n_auto').html('<p>' + data['content'] + '</p>');
                    $('#text_valoracion_i18n_auto_google').html(data['text_valoracion']);
                    $('#info_i18n_auto').html(data['text_i18n_auto']);
                }
            }
    });
}

function noCrawlComentBodega() {
    $.ajax({
        url:$('#portal_url_coment_bodega').val() + '/noCrawlContent',
        data: {'id_bodega': $('#id_bodega').val(), 'curr_lang': $('#curr_lang').val(), 'portal_url': $('#portal_url_coment_bodega').val()},
        dataType: 'json',
        type:'POST',
        error:
            function(){
                ;
            },
        success:
            function(data){
                if (data['res']) {
                    $('#content_desc').html('<sup style="font-weight:bold;color:#00F">*</sup><p>' + data['desc'] + '</p>');
                    if (data['too_long_desc'])
                        $('#too_long_desc').html(data['too_long_desc']);
                    $('#info_i18n_auto_coment_bodega').html(data['text_i18n_auto']);
                }
            }
    });
}

function toggleInsertCoupon() {
    if ($('#cupon_plegado').hasClass('show')) {
        // desplehamos para insertar cupón
        $('#cupon_plegado').removeClass('show');
        $('#cupon_plegado').addClass('hide');
        $('#cupon_desplegado').removeClass('hide');
        $('#cupon_desplegado').addClass('show');
        $($($('#codigo_cupon').next().children())[0]).attr('style', 'padding-bottom:95px');
    } else {
        // plegamos el insertar cupón
        $('#cupon_plegado').removeClass('hide');
        $('#cupon_plegado').addClass('show');
        $('#cupon_desplegado').removeClass('show');
        $('#cupon_desplegado').addClass('hide');
         $($($('#codigo_cupon').next().children())[0]).attr('style', 'padding-bottom:30px');
    }
}

function add_coupon() {
    var f = $('#form_modifyItems');
    $(f).attr('action', $(f).data('portal_url') + '/carrito/add_coupon');
    $(f).submit();
}

function editar_nombre_opiniones(){
    /* muestro el formulario para editar el nombre y hago un "disabled" del div del listado de productos  */
    var nombre_anterior = $('#comentarios_publicados_como').text();
    $('#nombre_usuario').val(nombre_anterior);
    $('#comentarios_publicados_como').text('');
    $('#formulario_nombre_usuario').removeClass('hide');
    $('#mensaje_nombre_usuario').addClass('hide');
    $('.tooltip-msg').css('pointer-events', 'none');
    $('.tooltip-msg').css('cursor', 'default');
    $('#listado_productos button').attr('disabled','disabled');
    $('#listado_productos a').css('pointer-events', 'none');
    $('#listado_productos a').css('cursor', 'default');
    $('#listado_productos').css('opacity', '0.5');
    $('.subject-opinion').prop("disabled", true);
    $('.text-area-opinion').prop("disabled", true);
    $('.p_contacto').hide();
    $('#nombre_usuario').focus();
}

$(document).on('mouseover','.tooltip-msg', function() {
    if(!$(this).data('tooltip')){
        $(this).tooltip().triggerHandler('mouseover');
    }
});

$(document).ready(function() {

    var MOBILE = location.href.indexOf('/mobile/') !== -1

  if($('#tg_tr_header').length > 0 && MOBILE) {
    $.ajax({
        url:'/async/get_info_tg_or_tr',
        dataType: 'json',
        type:'POST',
        data:{language: $('#curr_lang').val(), portal_url: window.portal_url},
        error:
            function() {
                console.log("error?");
            },
        success:
            function(data){
                $('#tg_tr_header').html(data);
            }
    });
  }

  if($('#tg_tr_slider').length > 0 && MOBILE) {
    $.ajax({
        url:'/async/get_info_tg_or_tr',
        dataType: 'json',
        type:'POST',
        data:{language: $('#curr_lang').val(), portal_url: window.portal_url, slider: true},

        error:
            function() {
                console.log("error?");
            },
        success:
            function(data){
                $('#tg_tr_slider').html(data);
            }

    });
  }

    $(document).on('click','.finalizarPedidoRemarkFB', function() {
        fbq('track', 'InitiateCheckout');
    });

    $(document).on('click','.toggle-guia-redaccion', function() {
        if ($(this).next().hasClass('show')) {
            // plegamos
            $(this).next().removeClass('show');
            $(this).next().addClass('hide');
            $(this).prev().addClass('glyphicon-chevron-right');
            $(this).prev().removeClass('glyphicon-chevron-down');
        } else {
            // desplegamos
            $(this).next().removeClass('hide');
            $(this).next().addClass('show');
            $(this).prev().removeClass('glyphicon-chevron-right');
            $(this).prev().addClass('glyphicon-chevron-down');
        }
    });

    $(document).on('click','.to-product-comments-stars', function() {
        $('html, body').animate({
            scrollTop: $("#product-comments-stars").offset().top -25
        }, 500);
    });

    $(document).on('click','.load-translation', function() {
        /*Escondo el mensaje Ver el texto traducido... */
        $(this).hide();
        /*muestro el mensaje Volver al texto original y la firma de google translate */
        $(this).next().show();
        $(this).next().next().show();

        var id_opinion = $(this).attr('data-id-opinion');
        var language = $(this).attr('data-language');
        var i = $(this).attr('data-i');

        $.ajax({
            url:'/async/loadTranslation',
            dataType: 'json',
            type:'POST',
            data: { id_opinion: id_opinion, language: language },

            error:
                function() {
                    console.log('loadTranslation desktop. error?');
                },
            success:
                function(data){
                    $('#titulo_original'+i).hide();
                    $('#titulo_traducido'+i).html(data['titulo_traducido']);
                    $('#titulo_traducido'+i).show();
                    $('#opinion_original'+i).hide();
                    $('#opinion_traducida'+i).html(data['opinion_traducida']);
                    $('#opinion_traducida'+i).show();
                }

        });
    });

    $(document).on('click','.load-original', function() {
        $(this).hide();
        $(this).prev().show();
        $(this).next().hide();

        var i = $(this).attr('data-i');

        $('#titulo_original'+i).show();
        $('#titulo_traducido'+i).hide();
        $('#opinion_original'+i).show();
        $('#opinion_traducida'+i).hide();
    });

    $(document).on('click','.load-more-prods-to-opine',function() {
        /* Si no hay nombre de usuario, no funcionan los botones */
        var comentarios_publicados_como = $('#comentarios_publicados_como').text();
        if (comentarios_publicados_como != ''){
            $(this).hide();
            var t = this;
            var productos_mostrados = $(this).attr('data-mostrados');
            var total_productos = $(this).attr('data-len-productos');
            var id_usuario = $(this).attr('data-id-usuario');
            var language = $(this).attr('data-idioma');
            var id_site = $(this).attr('data-id-site');
            var nombre_usuario = $('#comentarios_publicados_como').text();
            var cliente_vinissimus = $('#cliente_vinissimus').val();
            if (nombre_usuario == ''){
                nombre_usuario = cliente_vinissimus;
            }

            $.ajax({
                url:'/async/loadMoreProdsToOpine',
                dataType: 'json',
                type:'POST',
                data: { productos_mostrados: productos_mostrados, total_productos: total_productos, id_usuario: id_usuario, language: language, id_site: id_site, nombre_usuario: nombre_usuario},

                error:
                    function() {
                        console.log('loadMoreProdsToOpine. error extras.js');
                    },
                success:
                    function(data){
                        $($($(t).prev()).children()).append(data['html']);
                        $(t).attr('data-mostrados',data['productos_mostrados']);
                        if (data['span_ult_6_meses'] == false){
                            $('#span_ult_6_meses').removeClass('hide');
                        }
                        if (data['boton_ver_mas']){
                            $(t).show();
                        }
                    }

            });
        }
    });

    $(document).on('mouseout','.rating', function() {
        /* Si no hay nombre de usuario, no funcionan los botones */
        var comentarios_publicados_como = $('#comentarios_publicados_como').text();
        if (comentarios_publicados_como != ''){
            var star_type = $(this).attr('data-star-type');
            var id_producto = $(this).attr('data-id-producto');
            var ratings = $('#star-'+star_type+id_producto+' .rating');
            var attr_src = $(this)[0].getAttribute('src');
            var images_url = $(this).attr('data-images-url');
            if(attr_src.indexOf('marcada') < 0){
                for (var i=0;i<5;i++){
                    aux_src = ratings[i].getAttribute('src');
                    if (aux_src.indexOf('marcada') < 0) {
                        ratings[i].src = images_url+'/opinions/star-btn_sinmarcar-'+star_type+'.png';
                    }
                }
            }
        }

    });

    $(document).on('mouseover','.rating', function() {
        /* Si no hay nombre de usuario, no funcionan los botones */
        var comentarios_publicados_como = $('#comentarios_publicados_como').text();
        if (comentarios_publicados_como != ''){
            var nota = $(this).attr('data-nota');
            var star_type = $(this).attr('data-star-type');
            var id_producto = $(this).attr('data-id-producto');
            var ratings = $('#star-'+star_type+id_producto+' .rating');
            var attr_src = $(this)[0].getAttribute('src');
            var images_url = $(this).attr('data-images-url');
            if ($(this).hasClass('rating-gracias')){
                $('.rating').css('cursor', 'default');
            } else{
                $('.rating').css('cursor', 'pointer');
            }
            if(attr_src.indexOf('marcada') < 0){
                for (var i=0;i<5;i++){
                    aux_src = ratings[i].getAttribute('src');
                    if (aux_src.indexOf('marcada') < 0) {
                        ratings[i].src = images_url+'/opinions/star-btn_sinmarcar-'+star_type+'.png';
                    }
                }
                for (var i=0;i<nota;i++){
                    aux_src = ratings[i].getAttribute('src');
                    if (aux_src.indexOf('marcada') < 0) {
                        ratings[i].src = images_url+'/opinions/star-btn_hover.png';
                    }
                }
            }
        } else{
            $('.rating').css('cursor', 'default');
        }
    });


    $(document).on('click','.rating',function() {
        /* Si no hay nombre de usuario, no funcionan los botones */
        var comentarios_publicados_como = $('#comentarios_publicados_como').text();
        if (comentarios_publicados_como != ''){
            var nota = $(this).attr('data-nota');
            var star_type = $(this).attr('data-star-type');
            var id_producto = $(this).attr('data-id-producto');
            var ratings = $('#star-'+star_type+id_producto+' .rating');
            var images_url = $(this).attr('data-images-url');
            $('.nota-opinion'+id_producto).val(nota);
            $('.premi-formulario'+id_producto).removeClass('hide');
            $('.premi-sin-formulario'+id_producto).addClass('hide');
            $('.valoraciones'+id_producto).addClass('hide');
            switch (nota){
                case '1':
                    $('#valoracion1'+id_producto).removeClass('hide');
                    break;
                case '2':
                    $('#valoracion2'+id_producto).removeClass('hide');
                    break;
                case '3':
                    $('#valoracion3'+id_producto).removeClass('hide');
                    break;
                case '4':
                    $('#valoracion4'+id_producto).removeClass('hide');
                    break;
                case '5':
                    $('#valoracion5'+id_producto).removeClass('hide');
                    break;
            }

            for (var i=0;i<5;i++){
                ratings[i].src = images_url+'/opinions/star-btn_sinmarcar-'+star_type+'.png';

            }
            for (var i=0;i<nota;i++){
                ratings[i].src = images_url+'/opinions/star-btn_marcada.png';
            }
            $('#subject-opinion'+id_producto).focus();
        }
    });

    $(document).on('keyup','.text-area-opinion', function(){
        var id_producto = $(this).attr('data-id-producto');
        if (this.value){
            var words = this.value.match(/\S+/g).length;
            if (words < 19){
                $('#boton-enviar-opinion'+id_producto).prop('disabled',true);
                $('.contador-palabras'+id_producto).css('color','#ff0000');
                $('.contador-palabras'+id_producto).removeClass('hide');
                $('#cont-pal20-'+id_producto).removeClass('hide');
                $('#cont-pal1-'+id_producto).addClass('hide');
            } else if (words == 19){
                $('#boton-enviar-opinion'+id_producto).prop('disabled',true);
                $('.contador-palabras'+id_producto).css('color','#ff0000');
                $('.contador-palabras'+id_producto).removeClass('hide');
                $('#cont-pal20-'+id_producto).addClass('hide');
                $('#cont-pal1-'+id_producto).removeClass('hide');
            }
            else {
                // para habilitarlo, ademas ha de tener un subject
                if ( $('.subject-opinion'+id_producto).val().trim() != '' ) {
                    $('#boton-enviar-opinion'+id_producto).prop('disabled',false);
                }
                $('.contador-palabras'+id_producto).addClass('hide');
            }
            if (words > 150){
                var trimmed = $(this).val().split(/\s+/, 150).join(" ");
                $(this).val(trimmed + " ");
            }else{
               $('.count-word-opinion'+id_producto).text(20-words);
            }
        } else{
            $('.count-word-opinion'+id_producto).text('20');
            $('#boton-enviar-opinion'+id_producto).prop('disabled',true);
            $('.contador-palabras'+id_producto).css('color','#ff0000');
            $('.contador-palabras'+id_producto).removeClass('hide');
        }
    });

    $(document).on('keyup','.subject-opinion', function(){
        var id_producto = $(this).attr('data-id-producto');
        if (this.value.trim()){
            // para activar el boton enviar, debemos tener mas de 20 palabras en el textarea de la opinion (el subject lo tenemos,
            // porque ya le hemos hecho el trim)

            if ($('.text-area-opinion'+id_producto).val().trim() != '') {
                words = $('.text-area-opinion'+id_producto).val().match(/\S+/g).length;
                if (words < 20){
                    $('#boton-enviar-opinion'+id_producto).prop('disabled',true);
                } else {
                    $('#boton-enviar-opinion'+id_producto).prop('disabled',false);
                }
            } else {
                $('#boton-enviar-opinion'+id_producto).prop('disabled',true);
            }
        } else{
            $('#boton-enviar-opinion'+id_producto).prop('disabled',true);
        }
    });

    $(document).on('click','.borrar-text-area', function() {
        var id_producto = $(this).attr('data-id-producto');
        var star_type = $(this).attr('data-star-type');
        var images_url = $(this).attr('data-images-url');
        var ratings = $('#star-'+star_type+id_producto+' .rating');
        var text_area = $('.text-area-opinion'+id_producto);
        text_area.val('');
        $('.count-word-opinion'+id_producto).text('20');
        $('.subject-opinion'+id_producto).val('');
        $('#boton-enviar-opinion'+id_producto).prop('disabled',true);
        $('.contador-palabras'+id_producto).css('color','#ff0000');
        $('.contador-palabras'+id_producto).removeClass('hide');
        $('#cont-pal20-'+id_producto).removeClass('hide');
        $('#cont-pal1-'+id_producto).addClass('hide');
        $('.premi-formulario'+id_producto).addClass('hide');
        $('.premi-sin-formulario'+id_producto).removeClass('hide');
        $('.valoraciones'+id_producto).removeClass('hide');
        for(var i=1; i<=5; i++){
            $('#valoracion'+i+id_producto).addClass('hide');
            ratings[i-1].src = images_url+'/opinions/star-btn_sinmarcar-'+star_type+'.png';
        }
    });

    $(document).on('click','.boton-enviar-formulario', function(){
        /* Si no hay nombre de usuario, no funcionan los botones */
        var comentarios_publicados_como = $('#comentarios_publicados_como').text();
        if (comentarios_publicados_como != ''){
            var t = this;
            var id_producto = $(this).attr('data-id-producto');
            var nota = $('.nota-opinion'+id_producto).val();
            var titulo = $('.subject-opinion'+id_producto).val();
            var id_usuario = $(this).attr('data-id-usuario');
            var id_site = $(this).attr('data-id-site');
            var language = $(this).attr('data-idioma');
            var opinion = $('.text-area-opinion'+id_producto).val();
            var nombre_usuario = comentarios_publicados_como;
            var importe = $(this).attr('data-importe');
            var id_pedido = $(this).attr('data-id-pedido');

            $.ajax({
                url:'/async/insertOpinionPend',
                dataType: 'json',
                type:'POST',
                data: { id_producto: id_producto, nota: nota, titulo:titulo,
                        id_usuario:id_usuario, id_site:id_site, language:language, opinion:opinion,
                        nombre_usuario: nombre_usuario, importe: importe, id_pedido: id_pedido},

                error:
                    function() {
                        console.log('insertOpinionPend. error extras.js');
                    },
                success:
                    function(data){
                        $('#content-opinion'+id_producto).html(data['html']);
                        if(parseInt(importe) > 0){
                           $('.premi-formulario'+id_producto).addClass('hide');
                        }
                    }
            });
        }
    });

    $(document).on('click','.cambiar_nombre', function(){
        var t = this;
        var nombre_usuario = $.trim($('#nombre_usuario').val());
        var cliente_vinissimus = $('#cliente_vinissimus').val();
        if (nombre_usuario == ''){
            nombre_usuario = cliente_vinissimus;
        }

        $('#formulario_nombre_usuario').addClass('hide');
        $('#mensaje_nombre_usuario').removeClass('hide');
        $('#listado_productos a').css('pointer-events', '');
        $('#listado_productos a').css('cursor', 'pointer');
        $('#listado_productos').css('opacity', '');
        $('.subject-opinion').prop("disabled", false);
        $('.text-area-opinion').prop("disabled", false);
        $('.tooltip-msg').css('pointer-events', '');
        $('.tooltip-msg').css('cursor', 'pointer');
        $('.p_contacto').show();
        $('#comentarios_publicados_como').text(nombre_usuario);
        $('.subject-opinion').first().focus();
        $('.text-area-opinion').each(function(){
            var id_producto = $(this).attr('data-id-producto');
            $('.borrar-text-area'+id_producto).css('cursor','pointer');
            $('.borrar-text-area'+id_producto).css('text-decoration','');
            $('.borrar-text-area'+id_producto).css('pointer-events','');
            if (this.value){
                var words = this.value.match(/\S+/g).length;
                if (words < 19){
                    $('#boton-enviar-opinion'+id_producto).prop('disabled',true);
                    $('.contador-palabras'+id_producto).css('color','#ff0000');
                    $('.contador-palabras'+id_producto).removeClass('hide');
                    $('#cont-pal20-'+id_producto).removeClass('hide');
                    $('#cont-pal1-'+id_producto).addClass('hide');
                } else if (words == 19){
                    $('#boton-enviar-opinion'+id_producto).prop('disabled',true);
                    $('.contador-palabras'+id_producto).css('color','#ff0000');
                    $('.contador-palabras'+id_producto).removeClass('hide');
                    $('#cont-pal20-'+id_producto).addClass('hide');
                    $('#cont-pal1-'+id_producto).removeClass('hide');
                }
                else {
                    $('#boton-enviar-opinion'+id_producto).prop('disabled',false);
                    $('.contador-palabras'+id_producto).addClass('hide');
                }
            } else{
                $('.count-word-opinion'+id_producto).text('20');
                $('#boton-enviar-opinion'+id_producto).prop('disabled',true);
                $('.contador-palabras'+id_producto).css('color','#ff0000');
                $('.contador-palabras'+id_producto).removeClass('hide');
            }
        });
    });

    $(document).on('click', '.more-product', function(){
        var pack_id_product = $(this).attr('data-id-pack-product');
        var cantidad = parseInt($('#cantidad-pack-'+pack_id_product).val());
        var price = $('#price-pack-'+pack_id_product);
        var price_value = parseFloat(price.text().split('€')[0].split(',')[0] + '.'+price.text().split('€')[0].split(',')[1])
        var new_price = Math.round((price_value+(price_value/cantidad))*100) /100;
        cantidad = cantidad + 1;
        new_price = "" + new_price;
        if (new_price.split('.').length == 2){
            if (new_price.split('.')[1].length ==2 ){
                new_price = new_price.split('.')[0]+","+new_price.split('.')[1];
            }else{
                new_price = new_price.split('.')[0]+","+new_price.split('.')[1]+'0';
            }
        }else{
            new_price = new_price.split('.')[0]+",00"
        }
        price.text(new_price + ' €');
        $('#cantidad-pack-'+pack_id_product).val(cantidad);
        $('#value-pack-'+pack_id_product).val(cantidad);
    });

    $(document).on('click', '.less-product', function(){
        var pack_id_product = $(this).attr('data-id-pack-product');
        var cantidad = parseInt($('#cantidad-pack-'+pack_id_product).val());
        var price = $('#price-pack-'+pack_id_product);

        var price_value = parseFloat(price.text().split('€')[0].split(',')[0] + '.'+price.text().split('€')[0].split(',')[1])
        if (cantidad > 1){
            var new_price = Math.round((price_value-(price_value/cantidad))*100) /100;
            cantidad = cantidad - 1;
            new_price = "" + new_price;
            if (new_price.split('.').length == 2){
                if (new_price.split('.')[1].length ==2 ){
                    new_price = new_price.split('.')[0]+","+new_price.split('.')[1];
                }else{
                    new_price = new_price.split('.')[0]+","+new_price.split('.')[1]+'0';
                }
            }else{
                new_price = new_price.split('.')[0]+",00"
            }
            price.text(new_price + ' €');
            $('#cantidad-pack-'+pack_id_product).val(cantidad);
            $('#value-pack-'+pack_id_product).val(cantidad);
        }

    });
    $(document).on('click', '.block-cart', function(){
        var pack_id_product = $(this).attr('data-id-pack-product');
        $('#form-addcart-'+pack_id_product).submit();
    });


    //Eliminar imagen repetida Lightbox
    if (document.getElementsByClassName('clone')){
        $('.clone > .img-light').removeAttr("data-lightbox");
    }

    //Quitar el fondo amarillo (class warning) cuando el filtro Ofertas/Promociones está activo
    if (getParameterByName('promocion')) $("tr").removeClass("warning");


    //Ajustar el alto de las cuadriculas a mayor de la fila
    if (window.location.pathname.indexOf("/packs/index.html") != -1 && getParameterByName('display_as') == 'block'){
        cols = $("div.col-4");
        for (var i = 1; i < cols.length-1; i+=3) {
            newheight = cols[i].clientHeight;
            max = 3;
            if(i+2 > cols.length-1){
                max = 2;
            } else if (i+1 > cols.length-1){
                max = 1;
            }
            for (var j = 0; j < max; j++) {
                height = cols[i+j].clientHeight;
                height = parseInt(height);
                if (height > newheight) {
                    newheight = height;
                }
            }
            for (var j = 0; j < max; j++) {
                cols[i+j].style.height = newheight + "px";
            }
        }
    };



    /////ASYNC//////
    $('#header-search-text').autocomplete({
        width: 457,
        minChars: 2,
        serviceUrl:'/async/searchAuto?language=' + window.curr_lang,
        delimiter: /(,|;)\s*/, // regex or character
        deferRequestBy: 100, //miliseconds
        autoSubmit:true,
        noCache: false  //default is false, set to true to disable caching
    });

    $('#header-search').on('submit', function(){
        var search_valid = document.getElementById('header-search-text').value;
        search_valid = search_valid.replace(/^\s+/, '').replace(/\s+$/, '');
        if(search_valid === ''){
            $('.message-error-search').removeClass('hide');
            setTimeout(function(){
                $('.message-error-search').addClass('hide');
            }, 7000);
            return false;
        }
        return true
    });


    if($('#lastVisited').length > 0){
        $("#lastVisited").load("/" + window.curr_lang + "/portletLastVisitedCart", function(){});
    }

    if($('#home_fragment').length > 0){
        $("#home_fragment").load('/' + window.curr_lang + '/portletHomeFragmentCart?curr_lang=' + window.curr_lang, function(){});
    }

    if($('#alsoBought').length > 0){
        $("#alsoBought").load('/'+window.curr_lang+'/portletAlsoBoughtCart',
            function(){$('.show-carousel').animate({'opacity': 1}, 200, 'linear');$('.show-carousel').jcarousel({ scroll: 5 });});
    }

    if($('#alsoBoughtViews').length > 0){
        $("#alsoBoughtViews").load('/'+ window.curr_lang +'/portletAlsoBought?id_producto=' + $('#id_producto').attr('value'),
            function(){$('.show-carousel').animate({'opacity': 1}, 200, 'linear');$('.show-carousel').jcarousel({ scroll: 5 });});
    }

    if($('#lastVisited').length > 0){
        $("#lastVisited").load("/" + window.curr_lang + "/portletLastVisitedCart", function(){});
    }

    if($('#alsoInteresting').length > 0){
        $("#alsoInteresting").load("/" + window.curr_lang + "/portletAlsoInterestingCart", function(){});
    }

    if($('#ranking').length > 0){
        $("#ranking").load("/" + window.curr_lang + "/portletRankingCart", function(){});
    }

    if($('#similarProducts').length > 0){
        $("#similarProducts").load('/'+window.curr_lang+'/portletProdsSimilares?id_producto=' + $('#id_producto').attr('value'),
            function(){$('.show-carousel').animate({'opacity': 1}, 200, 'linear');$('.show-carousel').jcarousel({ scroll: 5 });});
    }

    if($('#ofertas').length > 0){
        $("#ofertas").load("/" + window.curr_lang + "/portletOfertas", function(){});
    }

    if($('#info_transporte').length > 0){
        $("#info_transporte").load('/'+window.curr_lang+'/portletInfoTransporte');
    }

    if($('#alsoBoughtGrp').length > 0){
        var id_vino_grp = $('#alsoBoughtGrp').attr('value')
        $("#alsoBoughtGrp").load("/"+window.curr_lang+"/portletAlsoBought?id_vino=" + id_vino_grp, function(){});
    }

    if ($('#modal-newsletter-promo').length > 0) {
        var shown = $.cookie('modal-newsletter-promo');
        if (!shown) {
            $('#modal-newsletter-promo').modal();
            $.cookie('modal-newsletter-promo', 'true', { expires: 365, path: '/' });
        }
    }

    if($('#modal-money').length > 0){
        $('#modal-money').modal();
    }

    if($('#modal-age').length > 0){
        $('#modal-age').modal();
    }

    if (window.insert_coupon && window.dp_cupon){
        $('html, body').animate({scrollTop: $("#cupon_desplegado").offset().top-125}, 2000);
    }

    var s = document.getElementById("sels");
    if (s) {
        s = s.value;
        selecciones = s.split(',');
        // a la primera le quitamos uno porque por defecto ya comienza con 1...
        selecciones[0]--;
        // selecciones es un array que contiene el numero de up's que debemos hacemos (simular clicks en +)
        for (var i = 0; i < selecciones.length; i++) {
            if (selecciones[i] > 0)
                update(i, parseInt(selecciones[i]));
        }
    }

    //mi_cuenta/opinar.html
    if (window.location.pathname.substring(3) == '/mi_cuenta/opinar.html'){
        if((!window.id_usuario) || (window.hash != window.hash_req) && window.opinar_activo){
            window.location=window.portal_url+"/mi_cuenta/login.html?destination="+window.portal_url+"/mi_cuenta/opinar.html";
        }
    }

    var id_producto = getParameterByName('id_producto');
    var nota = getParameterByName('nota');
    if (id_producto != null && (nota != null && nota != 0)){
        var star_type = $('#star-type-'+id_producto).val();
        var ratings = $('#star-'+star_type+id_producto+' .rating');
        var images_url = $('#images_url').val();
        $('.nota-opinion'+id_producto).val(nota);
        $('.premi-formulario'+id_producto).removeClass('hide');
        $('.premi-sin-formulario'+id_producto).addClass('hide');
        $('.valoraciones'+id_producto).addClass('hide');
        switch (nota){
            case '1':
            $('#valoracion1'+id_producto).removeClass('hide');
            break;
            case '2':
            $('#valoracion2'+id_producto).removeClass('hide');
            break;
            case '3':
            $('#valoracion3'+id_producto).removeClass('hide');
            break;
            case '4':
            $('#valoracion4'+id_producto).removeClass('hide');
            break;
            case '5':
            $('#valoracion5'+id_producto).removeClass('hide');
            break;
        }

        for (var i=0;i<5;i++){
            ratings[i].src = images_url+'/opinions/star-btn_sinmarcar-'+star_type+'.png';

        }
        for (var i=0;i<nota;i++){
            ratings[i].src = images_url+'/opinions/star-btn_marcada.png';
        }
        if ($('#comentarios_publicados_como').text() != ''){
            $('#subject-opinion'+id_producto).focus();
        } else {
            $('#nombre_usuario').focus();
            $('.subject-opinion').prop("disabled", true);
            $('.text-area-opinion').prop("disabled", true);
            $('.text-area-opinion-mobile').prop("disabled", true);
        }
    }
    /////

    var a = $('#queryfoot').autocomplete({
        serviceUrl:'/async/searchAuto?language=' + window.curr_lang,
        minChars:2,
        delimiter: /(,|;)\s*/, // regex or character
        maxHeight:400,
        width:399,
        zIndex: 9999,
        deferRequestBy: 100, //miliseconds
        autoSubmit:true,
        noCache: false  //default is false, set to true to disable caching
    });

    if (window.location.pathname.substring(3) == '/test_carousel.html'){
        var c = [{"content": "<div class='slide_inner'>contenido del carousel<\/div>", "content_button": "<div class='thumb'>button<\/div>"},
        {"content": "<div class='slide_inner'>contenido del carousel página 2<\/div>", "content_button": "<div class='thumb'>button<\/div>"}];
        jQuery("#flavor_1").agile_carousel({
            carousel_data: c,
            transition_time: 300,
            carousel_outer_height: 228,
            carousel_height: 228,
            slide_height: 230,
            carousel_outer_width: 1024,
            slide_width: 1024,
            timer: 0,
            continuous_scrolling: true,
            no_control_set: "hover_previous_button,hover_next_button"
        });
    }

    if($('#ids-productos-shopping-inline').attr('value')){
        var ids = $('#ids-productos-shopping-inline').attr('value').split(',');
        for (var i = 1; i < ids.length; i++) {
            $('#a-shop-in-' + ids[i]).popover({
                html    : true,
                content :  $('#shop-in-'+ids[i]).html()/* 'ok' + $(this).closest('p').attr('id')*/
            });
        }
    }

    if(document.getElementById('content_valoracion_i18n_auto')){
        var ajax_valoracion = $.ajax({
            url:$('#portal_url').val() + '/noCrawlContent',
            data: {'id_producto': $('#id_producto').val()},
            dataType: 'json',
            type:'POST',
            error:
            function(){
                ;
            },
            success:
            function(data){
                if (data['res']) {
                    $('#content_valoracion_i18n_auto').html('<p>' + data['content'] + '</p>');
                    $('#text_valoracion_i18n_auto_google').html(data['text_valoracion']);
                    $('#info_i18n_auto').html(data['text_i18n_auto']);
                }
            }
        });
    }

    if(document.getElementById('valoracion_ficha_limit')){
        $.ajax({
            url:$('#portal_url').val() + '/noCrawlContentFichaProducto',
            data: {'valoracion': $('#info_valoracion').html()},
            dataType: 'json',
            type:'POST',
            error:
            function(){
                ;
            },
            success:
            function(data){
                $('#valoracion_limit_prod').html('<p>' + data['valoracion'] + '</p>');
                $('#text_valoracion_google').html(data['text_valoracion']);
            }
        });
    }

    if(document.getElementById('valoracion_ficha_limit_google')){
        $.when(ajax_valoracion).done(function(){
            $.ajax({
                url:$('#portal_url').val() + '/noCrawlContentFichaProducto',
                data: {'valoracion': $('#content_valoracion_i18n_auto').html(), 'google': true},
                dataType: 'json',
                type:'POST',
                error:
                function(){
                    ;
                },
                success:
                function(data){
                    $('#valoracion_limit_prod').html('<p>' + data['valoracion_by_google'] + '</p>');
                    $('#text_valoracion_google').html(data['text_valoracion']);
                }
            });
        });
    }

    if(document.getElementById('info_i18n_auto_coment_bodega')){
        $.ajax({
            url:$('#portal_url_coment_bodega').val() + '/noCrawlContent',
            data: {'id_bodega': $('#id_bodega').val(), 'curr_lang': $('#curr_lang').val(), 'portal_url': $('#portal_url_coment_bodega').val()},
            dataType: 'json',
            type:'POST',
            error:
            function(){
                ;
            },
            success:
            function(data){
                if (data['res']) {
                    $('#content_desc').html('<sup style="font-weight:bold;color:#00F">*</sup><p>' + data['desc'] + '</p>');
                    if (data['too_long_desc'])
                        $('#too_long_desc').html(data['too_long_desc']);
                    $('#info_i18n_auto_coment_bodega').html(data['text_i18n_auto']);
                }
            }
        });
    }

    if(document.getElementById('id_provincia_h')){
        start = typeof start !== 'undefined' ? start : false;
        var id_provincia = document.getElementById("id_provincia_h").value;
        var select_provincias = document.getElementById("provincia");
        var id_pais = document.getElementById("s_id_pais").value;
        var id_pais_default = document.getElementById("id_pais_default").value;
        if (id_provincia == '00' || id_provincia == '') {
            if (id_pais == id_pais_default && select_provincias.selectedIndex == (select_provincias.length - 1) ) {
                select_provincias.selectedIndex = "0";
            } else if (id_pais != id_pais_default) {
                select_provincias.selectedIndex = select_provincias.length - 1;
            }
        } else {
            if (id_pais != id_pais_default)
                select_provincias.selectedIndex = select_provincias.length - 1;
            else
                if (!start && select_provincias.selectedIndex == (select_provincias.length - 1))
                    select_provincias.selectedIndex = "0";
            }
    }

    if($('#carousel_regiones_wrapper').length > 0){
        cargarSliderRegiones(jQuery('#carousel_regiones_wrapper'));
    }

});

function scrollAnchor(anchor){
    /* Hace scroll hasta el anchor que pasemos como parametro */
    $('html, body').animate({
            scrollTop: $('#'+anchor).offset().top
        }, 500);
}

function getParameterByName(name, url) {
    /* función que busca 'name' en la url actual (o pasada por parámetro)
        y nos devolverá el valor de la variable pasada por get con ese name:
        EJEMPLO:
        url: ?foo=lorem&bar=&baz
        var foo = getParameterByName('foo'); --> devuelve "lorem"
        Si no encuentra una variable con ese name devuelve NULL  */
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function nop() {
    ;
}

function loadTranslation() {
    ;
}

function loadMoreResults() {
    ;
}


////////ASYNC////////////
function recalculate() {
    jQuery('#form_modifyItems').submit();
}

function checkCart(element) {
    var total_lines = document.getElementById("total_lines").value;
    var different = false;
    for (var i = 0; i < total_lines; i++) {
        try {
            jQuery(element).parent().find(".success-mini-mini").css("text-decoration", "line-through");
            if (jQuery(element).val() == jQuery(element).parent().find(".success-mini-mini").attr("data-promo")) {
                jQuery(element).parent().find(".success-mini-mini").css("text-decoration", "none");
            }
        }
        catch(er) {}
        var qO = document.getElementById("qO" + i).value;
        var q = document.getElementById("q" + i).value;
        //console.log('qO = ' + qO + ' q = ' + q);
        if (q != qO) {
            // desactivar botones "Finalizar pedido"
            jQuery('#finalizarPedido1').addClass('btn-disabled');
            jQuery('#finalizarPedido1').click(function(e) {
                e.preventDefault();
            });
            jQuery('#finalizarPedido2').addClass('btn-disabled');
            jQuery('#finalizarPedido2').click(function(e) {
                e.preventDefault();
            });
            jQuery('#recalcularImportes').addClass('btn-warning');
            jQuery('#recalcularImportes').popover({
                html    : true,
                content : jQuery('#recalculate-message').html()
            });
            if (!jQuery('.popover').hasClass('in'))
                jQuery('#recalcularImportes').popover('show');
            different = true;
            break;
        }
    }
    if (!different) {
        jQuery('#finalizarPedido1').removeClass('btn-disabled');
        jQuery('#finalizarPedido1').off('click');
        jQuery('#finalizarPedido2').removeClass('btn-disabled');
        jQuery('#finalizarPedido2').off('click');
        jQuery('#recalcularImportes').removeClass('btn-warning');
        jQuery('#recalcularImportes').popover('hide');
        console.log("no diferente");
    }
}

function checkform ( form ){
    if ( form.cod_valid.value == "" ) {
        form.cod_valid.focus();
        return false;
    }
    return true ;
}

function updateLink() {
    var portal = document.getElementById("portalUrl").value;
    var id_pedido = document.getElementById("id_pedido").value;
    var hash = document.getElementById("hash").value;
    var url = portal + '/mi_cuenta/restricted/ver_cambiar_direccion_club.html?id_pedido=' + id_pedido + '&hash=' + hash + '&conf=False';
    document.getElementById("ver_sup").href = url;
    return true;
}

function roundNumber(num, dec) {
    var result = Math.round(num*Math.pow(10,dec))/Math.pow(10,dec);
    return result;
}

function formatPrice(price, pounds, withpoint) {
    var s_price = price.split('.');
    if (s_price.length == 1)
        price = price + '.00';
    else if (s_price[1].length != 2)
        price = price + '0';
    if (!pounds) {
        // euros. ver si tiene punto o coma
        if (withpoint) {
            // tiene blanco y .
            // XXX.YY
            price = price + '&nbsp;&euro;';
        } else {
            // tiene blanco y ,
            // XXX,YY
            price = price.replace('.',',') + '&nbsp;&euro;';
        }
    } else {
        // libras. ver si tiene punto o coma
        if (withpoint) {
            // no tiene blanco y tiene .
            // £XXX.YY
            price = '&pound;' + price;
        } else {
            // no tiene blanco y tiene ,
            // £XXX,YY
            price = '&pound;' + price.replace('.', ',');
        }
    }
    return price;
}

function updateFields() {
    var numselecciones = parseInt(document.getElementById("total_selecciones").value);
    for (var i = 0; i < numselecciones; i++)
        document.getElementById("numsel" + i).value = document.getElementById("sel" + i).innerHTML;
}

function totalSeleccionesAnteriores() {
    var numselecciones = parseInt(document.getElementById("total_selecciones").value);
    var tot = 0.00;
    for (var i = 1; i < numselecciones; i++)
        tot = tot + parseFloat(document.getElementById("preciosel" + i).value) * parseInt(document.getElementById("sel" + i).innerHTML);
    return tot;
}

function seleccionEscogidas() {
    var numselecciones = parseInt(document.getElementById("total_selecciones").value);
    var query_string = '&sels=';
    for (var i = 0; i < numselecciones; i++) {
        if (i != 0)
            query_string += ',' + document.getElementById("sel" + i).innerHTML;
        else
            query_string += document.getElementById("sel" + i).innerHTML;
    }
    return query_string;
}

function update(elemento, updown) {

    // actualizar contador de cajas seleccionadas
    var e = document.getElementById("sel"+elemento);
    var v = parseInt(e.innerHTML) + updown;
    if (v < 0)
        return ;
    e.innerHTML = v;

    // poner "recalculando.." en los campos que hay que esperar la respuesta del JSON
    var recalculando = jQuery('#recalculando').val();
    document.getElementById("transporte_sup").innerHTML = document.getElementById("total_sup").innerHTML = recalculando;
    if (document.getElementById("contrareembolso_sup"))
        document.getElementById("contrareembolso_sup").innerHTML = recalculando;

    // ver si escribiremos los precios con . o con ,
    var withpoint = document.getElementById("withpoint").value;
    if (withpoint == 'True')
        withpoint = true;
    else
        withpoint = false;

    // actualizar precio total de las cajas seleccionadas (para la selección actual)
    var precio_sel = parseFloat(document.getElementById("preciosel"+elemento).value);
    var iva = parseFloat(document.getElementById("iva").value);
    var e = document.getElementById("varpreciosel"+elemento);
    var pounds = (e.innerHTML.indexOf(' ') == -1 && e.innerHTML.indexOf('&nbsp;') == -1);
    var poundvalue = 1;
    if (pounds) {
        poundvalue = document.getElementById("poundvalue").value;
        document.getElementById("total_libras_sup").innerHTML = recalculando;
    }
    e.innerHTML = formatPrice((roundNumber(precio_sel * v * iva / poundvalue, 2)).toString(), pounds, withpoint);
    if (elemento > 0) {
        // se trata de alguna selección anterior. Actualizar el total selecciones anteriores
        var sels_ant = document.getElementById("tot_sels_ant");
        sels_ant.innerHTML = formatPrice((roundNumber(totalSeleccionesAnteriores() * iva / poundvalue, 2)).toString(), pounds, withpoint);
    }

    // hacer llamada JSON para updatear el objeto del pedido y obtener nuevos valores que escribiremos por pantalla
    var portal = document.getElementById("portalUrl").value;
    var tiene_iva = (roundNumber(iva,2) != 1.00)
    var id_medio_pago = document.getElementById("id_medio_pago").value;
    var selecciones = seleccionEscogidas();
    var id_pais = document.getElementById("id_pais").value;
    var id_provincia = document.getElementById("id_provincia").value;
    var url = portal + '/logic/construyePedidoClubSegunParams?ti=' + tiene_iva + '&mp=' + id_medio_pago + selecciones + '&idp=' + id_pais + '&idpv=' + id_provincia;
    jQuery.getJSON(url, function(data) {
        // la respuesta, data, es un diccionario del tipo:
        // {'tot_prods': pedido.getPrecioItemsIva(), 'transporte': pedido.getPrecioTransporteIva(), 'contrareembolso': pedido.getPrecioReembolsoIva(), 'total': pedido.getPrecioTotalIva()}
        // formatPrice((roundNumber(data['tot_prods'] / poundvalue, 2)).toString(), pounds, withpoint);
        document.getElementById("transporte_sup").innerHTML = formatPrice((roundNumber(data['transporte'] / poundvalue, 2)).toString(), pounds, withpoint);
        document.getElementById("total_sup").innerHTML = formatPrice((roundNumber(data['total'], 2)).toString(), false, withpoint);
        if (pounds)
            document.getElementById("total_libras_sup").innerHTML = formatPrice((roundNumber(data['total'] / poundvalue, 2)).toString(), pounds, withpoint);
        if (id_medio_pago == 'crbs')
            document.getElementById("contrareembolso_sup").innerHTML = formatPrice((roundNumber(data['contrareembolso'] / poundvalue, 2)).toString(), pounds, withpoint);
    });
}

function updateLink() {
    var portal = document.getElementById("portalUrl").value;
    var id_pedido = document.getElementById("id_pedido").value;
    var hash = document.getElementById("hash").value;
    var selecciones = seleccionEscogidas();
    var url = portal + '/mi_cuenta/restricted/ver_cambiar_direccion_club.html?id_pedido=' + id_pedido + '&hash=' + hash + '&conf=True' + selecciones;
    document.getElementById("ver_sup").href = url;
    return true;
}

function check_form_ficha(f) {
    res = true;
    if(!check_email(f.from.value)){
        f.from.focus();
        d = document.getElementById('msg1');
        d.style.color = "red";
        f.from.style.background = "#FFFF99";
        d.innerHTML='<tal:block><span i18n:translate="" tal:omit-tag="">Escriba un e-mail suyo *correcto*</span><span i18n:translate="" tal:omit-tag=""><span i18n:name="punt">:</span></span></tal:block>';
        res = false;
    }
    else{f.from.focus();
        d = document.getElementById('msg1');
        d.style.color = "black";
        f.from.style.background = "white";
        d.innerHTML='<tal:block><span i18n:translate="" tal:omit-tag="">Su dirección de correo electrónico</span><span i18n:translate="" tal:omit-tag=""><span i18n:name="punt">:</span></span></tal:block>';
    }
    if(!check_email(f.to.value)){
        f.to.focus();
        d = document.getElementById('msg2');
        d.style.color = "red";
        f.to.style.background = "#FFFF99";
        d.innerHTML='<tal:block><span i18n:translate="" tal:omit-tag="">Escriba una dirección de e-mail *correcta* para el destinatario</span><span i18n:translate="" tal:omit-tag=""><span i18n:name="punt">:</span></span></tal:block>';
        res = false;
    }
    else{f.to.focus();
        d = document.getElementById('msg2');
        d.style.color = "black";
        f.to.style.background = "white";
        d.innerHTML='<tal:block><span i18n:translate="" tal:omit-tag="">Dirección de correo electrónico del destinatario</span><span i18n:translate="" tal:omit-tag=""><span i18n:name="punt">:</span></span></tal:block>';
    }
    return res;
}

function resetToDefault() {
    var form = document.getElementById("form_dir_default");
    form.action = 'cambiarDirecClub';
    return form.submit();
}

function lanzarCobro4B(lanzar_cobro){
    if (lanzar_cobro == 1)
    {
        document.form4B.submit();
    }
}

function OrderPacksFunction(){
    var order_packs = $('#order_packs').val();
    var hostname = window.location.hostname;
    var protocol = window.location.protocol;
    var idioma = location.pathname.split('/')[0];
    var display_as = getParameterByName('display_as');
    var start = getParameterByName('start');
    if (display_as){
        display_as = '&display_as='+display_as;
    }else{
        display_as = '';
    }
    if (start){
        start = '&start='+start;
    }
    else{
        start=''
    }
    window.location.replace(protocol+'//'+hostname+'/'+idioma+'/packs/index.html?order_criteria='+order_packs+ display_as + start);
};

function showMore(id) {
 var t = jQuery('#tabla_regiones');
 jQuery('#mas_' + id).dialog({
   dialogClass: "dialog_filtros",
   position: { my: "left top", at: "left top", of: "#tabla_" + id, collision: "none" },
   show: {effect: 'drop', duration: 1000},
   minWidth: t.width(),
   maxWidth: t.width()
});
}

function showMorePageBoxes(id) {
 var t = jQuery('#tabla_principal');
 jQuery('#mas_' + id).dialog({
   dialogClass: "dialog_filtros",
   maxWidth: t.width(),
   minHeight: t.height(),
   minWidth: t.width(),
   position: { my: "left top", at: "left top", of: "#tabla_principal", collision: "none" },
   show: {effect: 'drop', duration: 1000},
});
 jQuery(".ui-icon.ui-icon-closethick").attr('title', jQuery('#span_cerrar_filtros').attr('value'));
}


function cargarSliderRegiones(elem) {
    var id_region = jQuery(elem).attr("data-idregion");
    $.ajax({
        url:'getCarouselRegiones?id_region=' + id_region,
        dataType: 'text',
        type:'POST',
        error:
        function(){
            jQuery(elem).hide();
        },
        success:
        function(data){
            if (data === undefined) {
                jQuery(elem).hide();
                return
            }
            jQuery(elem).html(data);
            $('.show-carousel-1').jcarousel({
                visible:1,
                scroll:1,
                width:300
            });
        }
    });
}

///////////////////////////

function checkPolitica(){
    if (!jQuery(".check-legal").is(":checked")) {
        $('.msj-legal').show();
        $('.check-legal').focus();
        return false;
    }
    return true;
}

function checkMayor(){
    if (!jQuery(".check-mayor").is(":checked")) {
        $('.msj-mayor').show();
        $('.check-mayor').focus();
        return false;
    }
    return true;
}

function checkNewsletter(){
    if (!jQuery(".check-news").is(":checked")) {
        $('.msj-news').show();
        $('.check-news').focus();
        return false;
    }
    return true;
}

function cerrarPopupNewsletter(){
    $('.close-news-pop').click();
    $('#modal-news-pop').modal();
}
